import { Cookies } from 'react-cookie';

import { newPositionValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const postNewPosition = async (position: newPositionValues) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    'clients-map/set_object_position/',
    {
      ...position,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
